__turbopack_context__.v({
  "alignRight": "ChatSubheader-module-scss-module__LQA7kW__alignRight",
  "button": "ChatSubheader-module-scss-module__LQA7kW__button",
  "left": "ChatSubheader-module-scss-module__LQA7kW__left",
  "root": "ChatSubheader-module-scss-module__LQA7kW__root",
  "title": "ChatSubheader-module-scss-module__LQA7kW__title",
});
